export default __webpack_public_path__ + "static/media/taken.2ed51fa2.png";